/**
 * @Author: WeiZisen
 * @Date: 2021-04-07 14:17:02
 * @LastEditors: WeiZisen
 * @LastEditTime: 2021-04-07 14:17:37
 * @Description: 验证规则-设备台账
 * @FilePath: \Vue_RebarProcess\src\validate\project-data\pro-standing-book.js
 */
export let rules = {
  serialCode: [{ required: true, message: '请填写设备编码', trigger: 'blur' }],
  name: [{ required: true, message: '请填写设备名称', trigger: 'blur' }],
  equipmentCode: [{ required: true, message: '请填写设备型号', trigger: 'blur' }],
  productPower: [{ required: true, message: '请填写设备产能', trigger: 'blur' }],
  processList: [{ required: true, message: '请选择加工工序', trigger: 'change' }],
  wareHouseId: [{ required: true, message: '请选择库位', trigger: 'change' }],
  ip: [{ required: true, message: '请填写IP地址', trigger: 'blur' }],
}
